<template>
    <div v-if="show" class="pagination">
        <button class="pagination-btn" :disabled="!hasPrev" @click="$emit('prev')">
            &larr; Назад
        </button>
        <span class="page-info">Страница {{ currentPage }}</span>
        <button class="pagination-btn" :disabled="!hasNext" @click="$emit('next')">
            Вперёд &rarr;
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            currentPage: {
                type: Number,
                required: true
            },
            hasNext: {
                type: Boolean,
                default: false
            },
            hasPrev: {
                type: Boolean,
                default: false
            },
            show: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
